import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "design-system/molecules/Select"
import { LayoutDashboard, Table } from "lucide-react"
import { useTranslation } from "react-i18next"
import { ViewFormat } from "./CampaignViewFormatContext"

type Props = {
  value: ViewFormat
  onChange: (value: ViewFormat) => void
}

export function ViewFormatSelector({ value, onChange }: Props) {
  const { t } = useTranslation()

  return (
    <Select value={value} onValueChange={(value) => onChange(value as ViewFormat)}>
      <SelectTrigger className="w-auto">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="chart">
          <div className="flex items-center gap-2">
            <LayoutDashboard className="size-4" />
            <span>{t("campaigns.detail.viewFormat.chart")}</span>
          </div>
        </SelectItem>
        <SelectItem value="table">
          <div className="flex items-center gap-2">
            <Table className="size-4" />
            <span>{t("campaigns.detail.viewFormat.table")}</span>
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  )
}
